import {
  Box,
  Button,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import React, { useState } from "react";
import SubmitQuiz from "../modals/SubmitQuiz";

const McqQues = () => (
  <Box className="column" sx={{ my: "2rem" }}>
    <Box className="row" justifyContent={"space-between"}>
      <Typography variant="h5">Question 1</Typography>
      <Typography variant="h5">Marks: 10</Typography>
    </Box>
    <Box className="row" sx={{ mt: "1rem" }}>
      <Typography variant="h6">This is question 1</Typography>
    </Box>
    <RadioGroup defaultValue={1} name="radio-buttons-group">
      {[1, 2, 3, 4].map((val) => (
        <Stack
          key={val}
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{
            mt: "1rem",
            backgroundColor: "rgba(0, 0, 0, 0.06)",
            borderRadius: 2,
            py: 1,
            px: 2,
          }}
        >
          <FormControlLabel value={val} control={<Radio />} label="Option 1" />
        </Stack>
      ))}
    </RadioGroup>
  </Box>
);
const SubQues = () => (
  <Box className="column" sx={{ my: "2rem" }}>
    <Box className="row" justifyContent={"space-between"}>
      <Typography variant="h5">Question 2</Typography>
      <Typography variant="h5">Marks: 20</Typography>
    </Box>
    <Box className="row" sx={{ mt: "1rem" }}>
      <Typography variant="h6">This is question 2</Typography>
    </Box>

    <TextField
      id="input-with-sx"
      label="Answer"
      variant="filled"
      fullWidth
      multiline
      rows={2}
      sx={{ width: "100%", mt: "1rem" }}
    />
  </Box>
);

export const Questions = () => {
  const [submitQuiz, setSubmitQuiz] = useState(false);
  const openSubmitQuiz = () => setSubmitQuiz(true);
  const closeSubmitQuiz = () => setSubmitQuiz(false);

  return (
    <>
      <Box
        className="column"
        sx={{
          mt: "20px",
          m: "0rem 4rem",
          p: "0 3rem",
          overflow: "scroll",
          height: "73.4vh",
          mb: 0,
        }}
      >
        <McqQues />
        <SubQues />
      </Box>
      <Box
        className="row"
        sx={{
          m: "0rem 4rem",
          p: "0",
          mt: "10px",
          justifyContent: "flex-end",
        }}
      >
        <Button onClick={openSubmitQuiz} variant="contained">
          {" "}
          Submit Quiz
        </Button>
      </Box>

      <SubmitQuiz isOpen={submitQuiz} close={closeSubmitQuiz} />
    </>
  );
};
